module.exports = __webpack_public_path__ + "components/home-header/static/header-3--huge@2x-c8c2a8a7ccc37be599af464d617ee0e4.jpg";